import { Button } from "antd";
import gql from "graphql-tag";
import PropTypes from "prop-types";
import React from "react";
import { Query } from "react-apollo";
import { Redirect } from "react-router-dom";

import { formatWithJsonSchema } from "../../formatters";
import { Fetch } from "../../api.js";
import { SHOULD_SHOW_EXTENDED_ENTITY_SCHEMA } from "../../config";

import EntityViewer from "../EntityViewer";
import OrgViewer from "./OrgViewer";
import IndViewer from "./IndViewer";

import styles from "./styles";

class EditEntityProcessButton extends React.Component {
    state = {
        nextTaskId: null,
    };

    static propTypes = {
        process: PropTypes.shape({
            label: PropTypes.string.isRequired,
            link: PropTypes.string.isRequired,
        }),
        ulid: PropTypes.string.isRequired,
    };

    startProcess = async link => {
        const ulid = this.props.ulid;
        const body = JSON.stringify({
            ulid,
        });
        const request = new Request(link, {
            method: "POST",
            body,
        });
        const data = await Fetch(request);

        this.setState({ nextTaskId: data.next_task_id });
    };

    renderRedirect = () => {
        const { nextTaskId } = this.state;
        return nextTaskId ? (
            <Redirect push to={`/tasks/${nextTaskId}/claim/`} />
        ) : null;
    };

    onClickHandle = event => {
        const process = this.props.hooks[0];
        this.startProcess(process.link);
        event.preventDefault();
        return false;
    };

    render() {
        const { hooks, permissions } = this.props;

        if (!hooks.length || !permissions.entity.canEdit) {
            return null;
        }
        return (
            <div className={styles.detailsHeader}>
                {this.renderRedirect()}
                <Button type="primary" icon="edit" onClick={this.onClickHandle}>
                    Edit Details
                </Button>
            </div>
        );
    }
}

const EDIT_ENTITY_ACTIONS = gql`
    query DetailTab_DetailViewEditEntityActions_Query($hookType: Int) {
        clientConfig {
            hooks(hookType: $hookType) {
                label
                link
            }
        }
        permissions {
            entity {
                canEdit
            }
        }
    }
`;

const EditEntityProcessButtonQuery = ({ entity }) => {
    // If type `ORGANISATION` (client_config_pb2.Hook.ENTITY_UPDATE_ORGANISATION_ACTION)
    // else type `INDIVDUAL` (client_config_pb2.Hook.ENTITY_UPDATE_INDIVIDUAL_ACTION)
    const hookType = entity.entityType === "ORGANISATION" ? 5 : 4;

    return (
        <Query query={EDIT_ENTITY_ACTIONS} variables={{ hookType }}>
            {apolloProps => {
                if (apolloProps.error) {
                    return <div>{apolloProps.error.message}</div>;
                } else if (apolloProps.loading) {
                    return <div>Loading...</div>;
                } else {
                    return (
                        <EditEntityProcessButton
                            ulid={entity.key.ulid}
                            permissions={apolloProps.data.permissions}
                            hooks={apolloProps.data.clientConfig.hooks}
                        />
                    );
                }
            }}
        </Query>
    );
};

const DetailTab = ({ entity, schema, canEdit }) => {
    const formattedEntity = formatWithJsonSchema({
        jsonSchema: schema,
        data: entity,
    });

    return (
        <React.Fragment>
            <EditEntityProcessButtonQuery entity={entity} />

            <br />

            {SHOULD_SHOW_EXTENDED_ENTITY_SCHEMA ? (
                formattedEntity.entityType === "Organisation" ? (
                    <OrgViewer entity={formattedEntity} />
                ) : (
                    <IndViewer entity={formattedEntity} />
                )
            ) : (
                <EntityViewer
                    entity={entity}
                    schema={schema}
                    editable={canEdit}
                />
            )}
        </React.Fragment>
    );
};

export default DetailTab;
